module.exports = __webpack_public_path__ + "71c4f5a9153f6b89d9d201561d0999c3.png";